import { MainLayout } from 'shared/ui/layout/main';

import { BonusProgramTabs } from '../tabs';

export function BonusProgramLayout() {
  return <MainLayout tabs={<BonusProgramTabs />} />;
}
